import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { cancelReservation } from '../../services/reservationService';
import '../../css/CancelReservationModal.css';

const CancelReservationModal = ({ reservation, onClose, onCancelled, onError }) => {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) return;
    setSubmitting(true);
    try {
      const result = await cancelReservation(reservation.reservationNumber, reason.trim());
      onCancelled(result?.data);
    } catch (error) {
      onError(error.message || '예약 취소에 실패했습니다.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="cancel-modal-overlay" onClick={onClose}>
      <div className="cancel-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cancel-modal-header">
          <h2>예약 취소 및 환불</h2>
          <button className="cancel-modal-close" onClick={onClose}>×</button>
        </div>

        <div className="cancel-modal-body">
          <div className="cancel-info-grid">
            <div className="cancel-info-row">
              <span className="cancel-info-label">예약번호</span>
              <span className="cancel-info-value">{reservation.reservationNumber}</span>
            </div>
            <div className="cancel-info-row">
              <span className="cancel-info-label">고객</span>
              <span className="cancel-info-value">{reservation.customerName} ({reservation.customerPhone || '-'})</span>
            </div>
            <div className="cancel-info-row">
              <span className="cancel-info-label">매장</span>
              <span className="cancel-info-value">{reservation.storeName}</span>
            </div>
            <div className="cancel-info-row">
              <span className="cancel-info-label">결제금액</span>
              <span className="cancel-info-value">{Number(reservation.finalAmount || 0).toLocaleString()}원</span>
            </div>
          </div>

          <div className="cancel-warning">
            관리자가 직접 예약을 취소하면 결제 금액 전액이 토스를 통해 환불됩니다. 이 작업은 되돌릴 수 없습니다.
          </div>

          <form onSubmit={handleSubmit}>
            <label className="cancel-form-label" htmlFor="cancel-reason">취소 사유</label>
            <textarea
              id="cancel-reason"
              className="cancel-form-textarea"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="환불 사유를 입력하세요 (필수)"
              rows={4}
              required
              disabled={submitting}
            />

            <div className="cancel-modal-actions">
              <button type="button" className="cancel-btn-secondary" onClick={onClose} disabled={submitting}>
                닫기
              </button>
              <button type="submit" className="cancel-btn-primary" disabled={submitting || !reason.trim()}>
                {submitting ? '처리 중...' : '취소 및 환불'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

CancelReservationModal.propTypes = {
  reservation: PropTypes.shape({
    reservationNumber: PropTypes.string.isRequired,
    customerName: PropTypes.string,
    customerPhone: PropTypes.string,
    storeName: PropTypes.string,
    finalAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onCancelled: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};

export default CancelReservationModal;